module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n              " + _vm._s(tag.name) + "\n              ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v("Изменить")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Документы\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxtDoc
    }
  })], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.documents), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createDocTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createDocContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openDoc(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Контакты\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openContact(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.contacts), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openContact(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6cfa088","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/favorite/CAgentPage.vue
// module id = 1135
// module chunks = 1